export const getUser = state => state.auth.user;
export const getUserName = state => state.auth.user?.name;
export const getUserRoles = state => state.auth.user?.roles;
export const getLoadingStatus = state => state.auth.loading;
export const getErrorStatus = state => state.auth.error;
